import { classNames } from "~/composables/classNames";

export const cn = classNames;
